import { createStyles, Grid, IconButton, makeStyles, Slide } from '@material-ui/core';
import React, { memo, useEffect, useState } from 'react';
import BlogComponent3 from './blogComponent3';
import LeftCircle from 'src/assets/icons/common/LeftCircle';
import BlogComponent from './blogComponent';
import { useBlogState } from './BlogProvider';
// interface Props {
//     blogs: any;
//     onSelectBlog: any;
// }

const useStyles = makeStyles((theme) =>
    createStyles({
        rowItem: { display: 'flex' },
        backIcon: { fill: theme.palette.primary.light, width: 48, height: 48 },
        backIconButton: { zIndex: 10, position: 'absolute', top: 0, alignSelf: 'flex-start' }
    })
);

export const BlogList3 = memo(({ blogs, detailTopLeft }: any) => {
    const classes = useStyles();
    const [selectedBlog, onSelectBlog] = useState<any>();
useEffect(()=>{
    
},[])
    return (
        <>
            {selectedBlog && (
                <IconButton className={classes.backIconButton} onClick={() => onSelectBlog(null)}>
                    <LeftCircle className={classes.backIcon} />
                </IconButton>
            )}
            {blogs.map((blog: any, index: any) => (
                <Grid item xs={12} sm={6} md={4} key={index} className={classes.rowItem}>
                    <BlogComponent3
                        {...blog}
                        detailTopLeft={detailTopLeft}
                        onSelectBlog={onSelectBlog}
                        selectedBlog={selectedBlog}
                    />
                </Grid>
            ))}
        </>
    );
});

export const BlogList2 = memo(({}: any) => {
    const classes = useStyles();
    // const theme = useTheme();
    // const xs = useMediaQuery(theme.breakpoints.down('xs'));
    // const md = useMediaQuery(theme.breakpoints.down('md'));
    const { blogList, closeDetail } = useBlogState();

    return (
        <>
            {blogList.map((blog, index) => (
                <Slide key={blog.id} in={!closeDetail} direction={index % 3 > 1 ? 'left' : 'right'}>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={index}
                        className={classes.rowItem}>
                        <BlogComponent {...blog} />
                    </Grid>
                </Slide>
            ))}
        </>
    );
});



export const BlogList = memo(({}: any) => {
    const classes = useStyles();
   
    const { blogList, closeDetail } = useBlogState();

    return (
        <>
            {blogList.map((blog, index) => (
                <Slide key={blog.id} in={!closeDetail} direction={index % 3 > 1 ? 'left' : 'right'}>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={index}
                        className={classes.rowItem}>
                        <BlogComponent {...blog} />
                    </Grid>
                </Slide>
            ))}
        </>
    );
});
